import React, { useState, useEffect }  from 'react';
import Constants from 'components/show_drawing/Constants.jsx';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import MyEventListener from 'components/common/MyEventListener.jsx'
import OptionsCommon from 'components/show_drawing/redraw_form/options/OptionsCommon.jsx';
import ShowHideChildOptions from 'components/show_drawing/redraw_form/options/ShowHideChildOptions.jsx';

const OptionIntegerWithRange = ({ id, drawing, option, unit, optionsUserChanged, addToOptionsUserChanged, setRedrawRequested, labelGroup = 'dimensions', inputName }) => {
  const submitName = inputName ?? option.name;
  const formattedValue = (value) => { return value }
  const redrawOnChange = true;
  const [isVisible, value, valueAutoCalculated, recommendedValue, onChange, showAbcHelperLine, changed, highlighted, _d_input_add_on_ref] = OptionsCommon( { formattedValue, id, drawing, option, unit, optionsUserChanged, addToOptionsUserChanged, setRedrawRequested, redrawOnChange, labelGroup } )
  const defaultOptions = () => {
    if(option.possible_values.length > 0) {
      return option.possible_values;
    }
    return Array.from({length: option.max_int_value - option.min_int_value + 1}, (_, i) => i + option.min_int_value)
  }
  const [options, _setOptions] = useState(defaultOptions())

  const getShowHideChildOptions = () => {
    if(option.children.length == 0) { return }
    return <ShowHideChildOptions id={id} option={option} />
  }

  if (!isVisible) { return <input type="hidden" name={submitName} value={value} /> }

  return (
    <div className={`${styles.row} ${styles.booleanGridItemWide}`}>
      <div className={`input-group ${highlighted ? styles.highlighted : ''}`}>
        <span className={`input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`} style={{'width': '100%' }}>
          {option.presented_name}
        </span>

        <select
          name={submitName}
          value={value}
          onChange={onChange}
          className={`${styles.select_for_int}`}
          onFocus={showAbcHelperLine}
          >
          {options.map( (i) => <option key={i} value={i}> {i} </option>  )}
        </select>

      </div>

      {valueAutoCalculated && <> <small> { t('drawing.this_has_been_automaticly_calculated') } </small> { getShowHideChildOptions()} {option.children.length == 0 && <br /> } </> }
      {!valueAutoCalculated && option.value_formula && recommendedValue &&  <> <small> {t('drawing.choose_option_recommmended')}: {recommendedValue} </small> { getShowHideChildOptions() } </>}
      {!valueAutoCalculated && !(option.value_formula && recommendedValue) &&  <> { getShowHideChildOptions() } </>}
    </div>
    )
}

export default OptionIntegerWithRange;
